import { Component, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { ObjectselectComponent } from "../objectselect/objectselect.component";
import { AppConfig } from "src/app/config";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-matchingrulenew",
  templateUrl: "./matchingrulenew.component.html",
  styleUrls: ["./matchingrulenew.component.scss"],
})
export class MatchingrulenewComponent implements OnInit {
  @ViewChild(ObjectselectComponent, { static: false })
  objectSelectComponent: ObjectselectComponent;

  guid: GUID;

  metaobjectId = "";
  objectName = "";
  currentTemplate = "objectSelect";
  mode = "";
  isLoading = false;
  isError = false;
  errorMessage = "";
  isDataLoaded = false;
  fields = [];
  fieldList = [];
  matchingMethodList = [];
  checkboxValueList = [
    { label: "True", value: true },
    { label: "False", value: false },
  ];
  picklistValueList = [];
  // currentTemplate: string = 'objectSelect';  // Controls which template to show
  filterForm: FormGroup;
  filteritems: FormArray;

  detailForm = this.fb.group({
    object: new FormControl({ value: "", disabled: true }, Validators.required),
    rulename: "",
    uniquename: "",
    description: "",
    active: true,
  });
  matchingRuleId: string;
  matchingRules: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    private appConfig: AppConfig
  ) {}

  ngOnInit() {
    this.guid = new GUID();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Refresh the page on URL change
        window.location.reload();
      }
    });
    this.route.queryParams.subscribe((params) => {
      // this.mode = this.route.snapshot.params.mode;
      this.currentTemplate = this.route.snapshot.params.template;
      this.mode = this.route.snapshot.params.mode;

      this.objectName = this.route.snapshot.params.objectname;
      this.metaobjectId = this.route.snapshot.params.objectid;
      this.matchingRuleId = this.route.snapshot.params.id;
    });

    this.detailForm.controls["object"].setValue(this.objectName);

    this.filterForm = this.fb.group({
      filteritems: this.fb.array([]),
      filterlogic: "1",
      active: true,
    });

    //create operator type picklist from operatortypes
    for (let i = 0; i < this.appConfig.matchingMethodTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.matchingMethodTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.matchingMethodList.push({
        value: this.appConfig.matchingMethodTypes[i],
        label: strLabel,
      });
    }

    if (this.mode.toLocaleLowerCase().trim() == "new") {
      this.getMetaFieldsForSelection().then((res) => {
        console.log("response1111", res);

        //load default done list first
        // this.loadDefaultDoneList();

        this.addFilterItem("", "", "", [], "", "");
        this.addFilterItem("", "", "", [], "", "");
        this.addFilterItem("", "", "", [], "", "");

        // this.isDataLoaded = true;
      }); //getMetaFieldsForSelection()
    } else {
      // this.checkCustomViewEditPermission().then((res) => {
      // console.log("response22222", res);
      if (!this.isError) {
        this.getMetaFieldsForSelection().then((res) => {
          console.log("response1111", res);

          // load metalayout details
          this.getMatchingRuleById().then((res) => {
            // console.log("this.metalayout", this.metalayout);
            // console.log("this.res", res);

            //assign metalayout detail data
            // this.assignMetalayoutData();

            if (this.filteritems == null) {
              this.addFilterItem("", "", "", "", "", "");
              this.addFilterItem("", "", "", "", "", "");
              this.addFilterItem("", "", "", "", "", "");
            } else if (this.filteritems.length == 1) {
              this.addFilterItem("", "", "", "", "", "");
              this.addFilterItem("", "", "", "", "", "");
            } else if (this.filteritems.length == 2) {
              this.addFilterItem("", "", "", "", "", "");
            }

            this.isDataLoaded = true;
          }); //getMetaLayoutByName()
        });
      }
      // });
    }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  fieldSelected(
    event: { id: any; fieldtype: any; options: string },
    index: number
  ) {
    console.log("fieldSelected");
    console.log("index", index);
    console.log("event", event);

    var i = 0;
    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      console.log(c);
      if (i == index) {
        console.log("matching", c);
        c.get("fieldid").setValue(event.id);
        c.get("fieldtype").setValue(event.fieldtype);
        c.get("options").setValue(event.options);
        if (c.get("matchingmethod").value == "") {
          c.get("matchingmethod").setValue("exact"); //default operator set
        }
        if (event.options != "") {
          var arr = JSON.parse(event.options);
          this.picklistValueList[index] = arr;
          c.get("matchingmethod").setValue("exact"); //default operator set
        }
        c.get("matchblankfields").setValue(false);
        break;
      }
      i++;
    }
  }

  addFilter(index: any) {
    if (this.filteritems != null && this.filteritems.length < 10) {
      this.addFilterItem("", "", "", "", "", "");
    }
  }

  removeFilter(index: any) {
    this.removeFilterItem(index);
  }

  createItem(
    id: any,
    name: any,
    ftype: any,
    opt: any,
    opr: any,
    vl: any,
    flogic: string
  ): FormGroup {
    return this.fb.group({
      //fieldlist: fldlist,
      //operatorlist: oplist,
      fieldid: id,
      fieldname: name,
      fieldtype: ftype,
      options: opt,
      matchingmethod: opr,
      matchblankfields: vl,
      filterlogic: flogic,
    });
  }

  addFilterItem(
    id: string,
    name: string,
    ftype: string,
    opt: string | any[],
    opr: string,
    vl: string,
    flogic = "AND"
  ): void {
    this.filteritems = this.filterForm.get("filteritems") as FormArray;
    this.filteritems.push(
      this.createItem(id, name, ftype, opt, opr, vl, flogic)
    );
    this.picklistValueList.push([]);
  }

  removeFilterItem(index: number) {
    if (index > 0) {
      this.filteritems.removeAt(index);
    }
  }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.objectName,
          },
        },
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            //add default --None-- into field list
            this.fieldList.push({
              value: "--None--",
              label: "--None--",
              fieldtype: "text",
              standard: true,
              options: [],
              id: "",
            });

            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              //skip converted field if object is lead
              if (
                this.objectName.toLowerCase().trim() == "lead" &&
                field.fieldname.toLowerCase() == "converted"
              )
                continue;

              //convert to titecase
              var strLabel = field.labelname;

              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              this.fieldList.push({
                value: field.fieldname,
                label: strLabel,
                fieldtype: field.fieldtype,
                standard: field.standard,
                options: field.options,
                id: field.id,
              });
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMatchingRuleById() {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          matchingrule: {
            id: this.matchingRuleId,
          },
        },
      };
      console.log(this.matchingRuleId);
      console.log(postOption);
      this.isLoading = true;
      this.dataService.getMatchingRuleById(postOption).subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.matchingRules = res.data.matchingrule;
            console.log("Doneeee****", this.matchingRules);
            if (this.matchingRules != null) {
              // this.fieldsDone = this.process.fields;
              // this.id = this.process.id;
              // this.name = this.process.name;

              this.detailForm.controls["rulename"].setValue(
                this.matchingRules.name
              );
              this.detailForm.controls["description"].setValue(
                this.matchingRules.description
              );
              this.detailForm.controls["uniquename"].setValue(
                this.matchingRules.uniquename
              );
              this.detailForm.controls["active"].setValue(
                this.matchingRules.active
              );

              this.filterForm.controls["filterlogic"].setValue(
                this.matchingRules.filterlogic
              );
            }

            var criterias = res.data.matchingrule.matchingrulecriteria;
            var index = 0;
            for (let i = 0; i < criterias.length; i++) {
              var criteria = criterias[i];

              console.log("fieldname", criteria.fieldname);
              //skip id type fields if there
              if (criteria.fieldname.toLowerCase() == "deleted") {
                console.log("deleted found.");
                continue;
              }
              //skip converted field if object is lead
              if (
                this.objectName.toLowerCase().trim() == "lead" &&
                criteria.fieldname.toLowerCase() == "converted"
              ) {
                console.log("converted found.");
                continue;
              }

              //get addnl field detail from fields
              var fldName = "";
              var fldLabel = "";
              var fldType = "";
              var fldOptions: string;

              for (let j = 0; j < this.fields.length; j++) {
                if (this.fields[j].id == criteria.fieldid) {
                  console.log(this.fields[j]);
                  fldName = this.fields[j].fieldname;
                  //convert to titecase
                  fldLabel = this.fields[j].labelname;
                  fldLabel = fldLabel[0].toUpperCase() + fldLabel.slice(1);
                  fldType = this.fields[j].fieldtype;

                  if (this.fields[j].options != null) {
                    fldOptions = this.fields[j].options;
                  }
                  //console.log("fldOptions", fldOptions);
                  break;
                }
              }

              //add item
              console.log("criteria", criteria);
              this.addFilterItem(
                criteria.fieldid,
                fldName,
                fldType,
                fldOptions,
                criteria.matchingmethod,
                criteria.matchblankfields,
                criteria.value
              );
              if (fldOptions != null) {
                var arr = JSON.parse(fldOptions);
                this.picklistValueList[index] = arr;
              }

              index++;
            }

            this.isLoading = false;
          } else {
            console.log("no data");
            this.isLoading = false;
            //this.resetDetailFormControls();
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      );
    });
  }

  next() {
    console.log(this.objectSelectComponent);

    this.metaobjectId = this.objectSelectComponent.metaobjectid;
    this.objectName = this.objectSelectComponent.objectname;

    console.log(this.metaobjectId);
    console.log(this.objectName);

    if (this.metaobjectId == "" || this.metaobjectId == undefined) {
      this.showWarning("Select object to proceed");
      return;
    }

    // console.log(this.currentTemplate)
    this.currentTemplate = "create"; // Switch to another template

    this.router.navigateByUrl(
      "home/matchingrule/create/new/" +
        this.objectName +
        "/" +
        this.metaobjectId
      // "home/matchingrule/create/new"
    );
  }

  previous() {
    this.router.navigateByUrl(
      "home/matchingrule/objectSelect/new"
      // "home/matchingrule/create/new"
    );
  }

  cancel() {
    this.router.navigateByUrl("home/matchingrulelist");
  }

  save() {
    if (this.detailForm.controls["rulename"].value.toString().trim() == "") {
      this.showWarning("Name is mandatory");
      return;
    }
    if (this.detailForm.controls["uniquename"].value.toString().trim() == "") {
      this.showWarning("Unique name is mandatory");
      return;
    }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.matchingRuleId = this.guid.getGUID("matchingrule");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      // profileid: userDetail.profileid,
      // profilename: userDetail.profilename,
      data: {
        matchingrule: {
          id: this.matchingRuleId,
          metaobjectid: this.metaobjectId,
          metaobjectname: this.objectName,

          mode: this.mode,
          name: this.detailForm.controls["rulename"].value.trim(),
          uniquename: this.detailForm.controls["uniquename"].value.trim(),
          description: this.detailForm.controls["description"].value.trim(),
          active: this.detailForm.controls["active"].value,
          filterlogic: this.filterForm.controls["filterlogic"].value,
          matchingrulecriteria: [],
        },
      },
    };

    var arrfilters = [];

    var arrayControl = this.filterForm.get("filteritems") as FormArray;

    for (let c of arrayControl.controls) {
      console.log(c);
      var fieldId = c.get("fieldid").value;
      var fieldName = c.get("fieldname").value;
      var fieldType = c.get("fieldtype").value;
      var matchblankFields = c.get("matchblankfields").value;
      // var type = c.get("type").value;
      var matchingmethod = c.get("matchingmethod").value;
      if (
        matchingmethod.toLowerCase().trim() == "--none--" ||
        matchingmethod.toLowerCase().trim() == ""
      )
        matchingmethod = "";

      // var value = c.get("fieldvalue").value;
      // if (value.toLowerCase().trim() == "--none--") value = "";
      // if (value == "--none--") value = "";

      if (fieldId != "" && matchingmethod != "") {
        var lookupFilter = {
          id: this.guid.getGUID("matchingrulecriteria"),
          metaobjectid: this.metaobjectId,
          metaobjectname: this.objectName,
          matchingruleid: this.matchingRuleId,
          fieldid: fieldId,
          fieldname: fieldName,
          fieldtype: fieldType,
          matchingmethod: matchingmethod,
          matchblankfields: matchblankFields,
          // value: value,
          // type: type,
          // filterlogic: c.get("filterlogic").value,
          // filtertype: this.filterForm.controls["filtertype"].value,
        };

        //push it to array
        arrfilters.push(lookupFilter);
      }
    }
    postOption.data.matchingrule.matchingrulecriteria = arrfilters;

    console.log("filter *****", arrfilters);
    console.log(postOption);

    this.isLoading = true;
    this.dataService.upsertMatchingRule(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("home/matchingrulelist");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
